import calc from '@/lib/calc'
/**
 * @function calPrice
 * @Description:  计算价格，防止精度丢失
 * @param methods: + - * /
 * @param calList 计算的数组
 * @param preVal
 * @param nextVal
 */
export function calPrice(methods,preVal,nextVal,calList){
  switch (methods){
    case '+':
    /*  return calList.reduce((prev, cur, index, arr)=>{
        return calc.add(prev, cur);
      });*/
      return calc.add(preVal, nextVal);
    case '-':
  /*    return calList.reduce((prev, cur, index, arr)=>{
        return calc.sub(prev, cur);
      });*/
      return calc.sub(preVal, nextVal);
    case '*':
     /* return calList.reduce((prev, cur, index, arr)=>{
        return calc.mul(prev, cur);
      });*/
     if(nextVal === 0){
       return 0
     }
      return calc.mul(preVal, nextVal);
    case '/':
      /*  return calList.reduce((prev, cur, index, arr)=>{
        return calc.div(prev, cur);
      });*/
      // 如果除数是 0 ，则结果返回0
      if(nextVal === 0){
        return 0
      }
      return calc.div(preVal, nextVal);
    case 'round':
      return calc.round(preVal, nextVal);
    default :
      return calc(preVal)
  }
};


export function handleDM100(originData,keyList,type){
  if(originData instanceof Array){
    if(originData.length > 0){
      ;(originData || []).forEach((fval,findex) => {
        ;(keyList || []).forEach((sval,sindex) => {
          if(fval[sval]){
            if(type == '*'){
              originData[findex][sval] = fval[sval] * 100
            }else{
              originData[findex][sval] = fval[sval] / 100
            }
          }
        })
      })
    }
  }else if(originData instanceof Object){
    ;(keyList || []).forEach((fval,findex) => {
      if(type == '*'){
        originData[fval] = originData[fval] * 100
      }else{
        originData[fval] = originData[fval] / 100
      }
    })
  }else{
    if(type == '*'){
      originData = originData * 100
    }else{
      originData = originData / 100
    }
  }
  return originData;
}

export function multiply100(originData,keyList){
  return handleDM100(originData, keyList, '*')
}

export function divide100(originData,keyList){
  return handleDM100(originData, keyList, '/')
}



// WEBPACK FOOTER //
// ./src/utils/calc.js